// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hb3w{width:calc(33.33% - .8rem);max-width:12rem;margin:1.5rem .4rem;text-align:center}.hb3w img{max-width:5.6rem;margin:0 auto;display:block}.hb3w figcaption{margin:.8rem 0 0}._2EBG{max-width:18rem;margin:.8rem 0;display:flex;align-items:center;flex-direction:column;text-align:center;flex:1}._2EBG img{max-width:5.6rem;margin:.6rem}._2EBG figcaption{margin:0}@media (min-width:36em){._2EBG{width:100%;margin:.8rem 1rem .8rem 0;flex-direction:row;text-align:left;text-align:initial;flex:auto}}@media (min-width:36em){html[dir=rtl] ._2EBG{width:100%;margin:.8rem 0 .8rem 1rem}}", ""]);
// Exports
exports.locals = {
	"icon": "hb3w",
	"icon__horizontal": "_2EBG"
};
module.exports = exports;
